import { CanDeactivateFn } from '@angular/router';

export interface UnsavedChangesComponent {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesComponent> = (component) =>
  !component.hasUnsavedChanges() ||
  window.confirm('Do you want to leave this page? Your unsaved changes will be lost.');
